import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

import { AUTH_LOGOUT, AUTH_SIGNUP_RESET } from './auth/actions';

import authReducer from './auth/reducer';
import meReducer from './me/reducer';
import householdMemberReducer from './householdMember/reducer';
import persistedSignupDataReducer from './persistedSignupData/reducer';
import { reducer } from './devTools/devTools';
import { includeDevTools } from '../constants';

const persistConfig = {
  storage,
  blacklist: ['status'],
};

const persistedAuthReducer = persistReducer(
  { ...persistConfig, key: 'auth' },
  authReducer,
);
const persistedMeReducer = persistReducer(
  { ...persistConfig, key: 'me' },
  meReducer,
);

export default combineReducers({
  auth: persistedAuthReducer,
  me: persistedMeReducer,
  householdMember: householdMemberReducer,
  persistedSignupData: persistedSignupDataReducer,
  ...(includeDevTools ? { devTools: reducer } : {}),
});
